import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {FeatureSelectItem} from './featureSelectItem';

@customElement('feature-reduced-list-select-item')
export class FeatureReducedListSelectItem extends FeatureSelectItem {

	static styles = [
		FeatureSelectItem.styles,
		css`
		  :host {
			list-style: none;
		  }
		  .item {
			position: relative;
		  }
		  .item.disabled {
			margin-bottom: 0;
		  }
		  .item button {
			height: var(--height-widget);
			transition: background-color 0.4s, color 0.4s;
			padding: 0.5em 0.5em;
			line-height: 120%;
			margin: 0;
			border: var(--border-widget);
			cursor: pointer;
			width: 100%;
			text-align: left;
			overflow: hidden;
		  }

		  button:hover {
			color: var(--color-white);
		  }

		  .selected button {
			color: var(--color-text-widget-active);
			border: var(--border-widget-active);
			background-color: var(--color-background-widget-active);
		  }

		  .fixed button {
			border: var(--border-widget-fixed);
			pointer-events: none;
		  }

		  .disabled button {
			padding: 0.5em 0;
			line-height: 0;
			margin: 0;
			display: none;
			color: var(--color-grey5);
		  }

		  .disabled button:hover {
			color: var(--color-white);
		  }
		`];

	render() {
		return html`
			<div class="item ${classMap({selected: this.isIncluded(), disabled: !this.canBeIncluded(), fixed: !this.canBeExcluded()})}">
				<button @click="${this.toggleDecision}">
					<trans-label key="${this.feature.variableId}" value="${this.featureValue.featureValueId}" context="FV"></trans-label>
				</button>
				${when(this.getInfoText() !== '', () => html`
					<div class="hoverinfo">
						<div class="content">
							${this.getInfoText()}
						</div>
					</div>
				`)}
			</div>
		`;
	}
}
